/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InstallUrlResponse
 */
export interface InstallUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof InstallUrlResponse
     */
    authUrl: string;
}

/**
 * Check if a given object implements the InstallUrlResponse interface.
 */
export function instanceOfInstallUrlResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "authUrl" in value;

    return isInstance;
}

export function InstallUrlResponseFromJSON(json: any): InstallUrlResponse {
    return InstallUrlResponseFromJSONTyped(json, false);
}

export function InstallUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstallUrlResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'authUrl': json['authUrl'],
    };
}

export function InstallUrlResponseToJSON(value?: InstallUrlResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'authUrl': value.authUrl,
    };
}

